import { render, staticRenderFns } from "./BaseDeceasedDonor.vue?vue&type=template&id=89cb4c72"
import script from "./BaseDeceasedDonor.vue?vue&type=script&lang=ts"
export * from "./BaseDeceasedDonor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports